function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgMoveIconFilled = function SvgMoveIconFilled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "b7aa9bde-49ca-46ec-8220-0511bbdd8752",
    viewBox: "0 0 20.3 17.3"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M10.5.09A2.51 2.51 0 1 0 13 2.6 2.51 2.51 0 0 0 10.5.09"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M9 5.21a1.7 1.7 0 0 0-1 .3l-3.8 2.9a1.7 1.7 0 0 0-.3 2.3 1.42 1.42 0 0 0 1.18.65 2.47 2.47 0 0 0 1.4-.57L8 9.61v1.8l-4.1 3a1.77 1.77 0 0 0-.6 1.69H.59a.58.58 0 0 0-.59.59.59.59 0 0 0 .59.59h19.12a.59.59 0 0 0 .59-.59.58.58 0 0 0-.59-.59h-4a1.8 1.8 0 0 0 .09-.57V13a2.34 2.34 0 0 0-1.9-2.3 3.6 3.6 0 0 0-1.1-.1v-1l1.28 1a3.3 3.3 0 0 0 1.76.72 1.38 1.38 0 0 0 1.06-.47c1.09-1.19-.26-2.36-.4-2.47l-3.3-2.57a4 4 0 0 0-1.76-.59H9ZM7.19 16.1l2.9-2.15h2.3v1.9a2 2 0 0 0 0 .29Z"
  }));
};
export default SvgMoveIconFilled;